import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BrandLogo } from '@/components/ui/brand-logo'

/**
 * Shared footer for public/marketing pages:
 * LandingPage, PricingPage, AboutPage, ContactPage.
 *
 * Inner wrapper: max-w-[var(--content-width-wide)] (1200px) with responsive padding.
 */
const footerLinkClass =
  'hit-area text-sm rounded-[var(--radius-sm)] text-[var(--text-public-secondary)] hover:text-[var(--text-public-primary)] transition-colors focus-ring'

export function SiteFooter() {
  const { t } = useTranslation()

  return (
    <footer className="chrome-on-dark border-t border-[var(--hairline-on-dark)] py-8 bg-[var(--surface-public)]">
      <div className="max-w-[var(--content-width-wide)] mx-auto px-4 sm:px-6 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm text-[var(--text-public-secondary)]">
          <BrandLogo size="sm" asLink={false} tone="onDark" muted />
          <span>&copy; {new Date().getFullYear()} EventRipple</span>
        </div>
        <div className="flex flex-wrap gap-6">
          {/* Hjelp står FØRST, foran de juridiske lenkene. Det er den eneste
              raden her noen har et aktivt behov for; vilkår og personvern er
              der fordi de skal være der. */}
          <Link to="/hjelp" className={footerLinkClass}>
            {t('help.navLabel')}
          </Link>
          <Link to="/terms" className={footerLinkClass}>
            {t('landing.footer.terms')}
          </Link>
          <Link to="/privacy" className={footerLinkClass}>
            {t('landing.footer.privacy')}
          </Link>
          <Link to="/cookies" className={footerLinkClass}>
            {t('landing.footer.cookies')}
          </Link>
        </div>
      </div>
    </footer>
  )
}
